import { cn } from '../../../../cn/cn';

export type ToastAlertWidth = 'full' | 'fit';

/**
 * The Alert in a ToastViewport. Adds only a width and the pointer events the
 * viewport turned off.
 *
 * `width` defaults to `'full'`; app-customer uses `'fit'`. Below 600px it is
 * full width either way so a phone message doesn't wrap into a column.
 */
const BASE =
  'pointer-events-auto w-full shadow-md sm:min-w-[288px] sm:max-w-[568px]';

export const toastAlertClasses = ({
  width,
  className,
}: {
  width?: ToastAlertWidth;
  className?: string;
}): string => cn(BASE, width === 'fit' && 'sm:w-auto', className);
